/* eslint-disable @typescript-eslint/no-explicit-any */
import { type Logger } from './model.js';
import { queueLogFns } from './queue.js';
import { initSentry } from './sentry.js';

/**
 * Queue calls to the logger until after init so that
 * we don't miss sending anything to Sentry or DD.
 */
const consoleKeys = Object.keys(console) as (keyof Console)[];
export const logger = consoleKeys.reduce<Logger>((acc, key) => {
  // Typings get weird here between the Node/Browser Console types
  acc[key] = console[key] as any;
  return acc;
}, {} as Logger);
const flushQueue = queueLogFns(logger, consoleKeys);

/**
 * Initialize the logger by patching with calls to Sentry for errors and warnings,
 * and sending all logs to Datadog.
 */
export const buildLoggerInit = (
  ...inits: (() => ((logger: Logger) => Promise<void>) | undefined)[]
) => {
  return async () => {
    if (process.env.NEXT_PUBLIC_SENTRY_DSN) {
      await initSentry(logger);
    }
    await Promise.all(
      inits.map(async (init) => {
        const initer = init();
        return initer?.(logger);
      }),
    );
    flushQueue();
  };
};
